import { render } from "./NewRequisitionForm.vue?vue&type=template&id=3baac7ae"
import script from "./NewRequisitionForm.vue?vue&type=script&lang=js"
export * from "./NewRequisitionForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__